import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../layouts/dashboard';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';

const ListFilter = (props: any) => {
  return <Filter {...(props || {})}></Filter>;
};

const RewardsTaskList = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  return (
    <DashboardContent>
      <PermissionGuard resource="rewards-task" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.rewardsTask')}
          links={[
            {
              name: translate('resource.rewardsTask'),
              href: `/${Resources.agents}`,
            },
            { name: translate('resource.list') },
          ]}
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            perPage={10}
            exporter={false}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="swap-chains" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <TextField
                  source="id"
                  label="module.rewardsTask.id"
                  sortable={false}
                />
                <TextField
                  source="name"
                  label="module.rewardsTask.name"
                  sortable={false}
                />
                <TextField
                  source="userCount"
                  label="module.rewardsTask.userCount"
                  sortable={false}
                />
                <TextField
                  source="contractVolumeThreshold"
                  label="module.rewardsTask.contractVolumeThreshold"
                  sortable={false}
                />
                <TextField
                  source="directCommissionRate"
                  label="module.rewardsTask.directCommissionRate"
                  sortable={false}
                />
                <TextField
                  source="extendedCommissionRate"
                  label="module.rewardsTask.extendedCommissionRate"
                  sortable={false}
                />
                <TextField
                  source="indirectCommissionRate"
                  label="module.rewardsTask.indirectCommissionRate"
                  sortable={false}
                />
                <TextField
                  source="makerFeeRate"
                  label="module.rewardsTask.makerFeeRate"
                  sortable={false}
                />
                <TextField
                  source="memeFeeRebate"
                  label="module.rewardsTask.memeFeeRebate"
                  sortable={false}
                />
                <TextField
                  source="memeVolumeThreshold"
                  label="module.rewardsTask.memeVolumeThreshold"
                  sortable={false}
                />
                <TextField
                  source="takerFeeRate"
                  label="module.rewardsTask.takerFeeRate"
                  sortable={false}
                />
                <TextField
                  source="totalCommission"
                  label="module.rewardsTask.totalCommission"
                  sortable={false}
                />
                <TextField
                  source="totalVolumeUsd"
                  label="module.rewardsTask.totalVolumeUsd"
                  sortable={false}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default RewardsTaskList;
